import script from "./EditorPagehead.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorPagehead.vue?vue&type=script&setup=true&lang=js"

import "./EditorPagehead.vue?vue&type=style&index=0&id=5336e2f2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5336e2f2"]])

export default __exports__